import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { LinearProgress } from '@material-ui/core';
import { defaultEnvColor } from 'theme';

const logo = require(process.env.REACT_APP_LOGO);
/*
const THEME_CACHE_KEY = 'cachedThemeConfig';
const getCachedTheme = () => {
    try {
        const raw = localStorage.getItem(THEME_CACHE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

const setCachedTheme = (theme, brandLogo) => {
    try {
        localStorage.setItem(THEME_CACHE_KEY, JSON.stringify({ theme, brandLogo }));
    } catch {
        // storage full or unavailable — fail silently
    }
};*/

const LoadingOverlay = () => {
    //const cachedTheme = getCachedTheme();

    const [themeConfig, setThemeConfig] = useState(null);
    const [loadingTheme, setLoadingTheme] = useState(true);

    useEffect(() => {
        //if (_.isNil(cachedTheme)) {
        fetch(process.env.REACT_APP_API_URL + '/app/config/default', { credentials: 'include' })
            .then(async res => {
                if (res.ok) {
                    const data = await res.json();
                    const theme = _.get(data, 'theme', null);
                    const brandLogo = _.get(data, 'brandLogo', null);
                    //setCachedTheme(theme, brandLogo);
                    setThemeConfig({ theme, brandLogo });
                }
            })
            .catch(() => {
                // network error — cached theme (if any) will be used
            })
            .finally(() => {
                setLoadingTheme(false);
            });
        //}
    }, []);

    if (loadingTheme && !themeConfig) {
        return (
            <div
                id="loading-overlay"
                className="loading-overlay"
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    zIndex: 9999999,
                    backgroundColor: '#ffffff'
                }}
            >
                <LinearProgress style={{ width: '60vw', maxWidth: '150px', marginBottom: '50vh' }} />
            </div>
        );
    }

    const backgroundColor = _.get(themeConfig, 'theme.light.primary', defaultEnvColor);
    const logoToDisplay = _.get(themeConfig, 'brandLogo.override', false) ? _.get(themeConfig, 'brandLogo.url') : logo;

    return (
        <div
            id="loading-overlay"
            className="loading-overlay"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-end',
                zIndex: 9999999,
                backgroundColor
            }}
        >
            <img
                src={logoToDisplay}
                alt={`${process.env.REACT_APP_BRAND_NAME} logo`}
                style={{
                    width: '80vw',
                    height: 'auto',
                    maxHeight: '250px',
                    maxWidth: '250px',
                    marginBottom: '16px'
                }}
            />
            <LinearProgress style={{ color: 'white', width: '60vw', maxWidth: '150px', marginBottom: '50vh' }} />
        </div>
    );
};

export default LoadingOverlay;
